/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Fragment, useEffect, useState } from "react";
import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import MaterialTable, { MTableToolbar } from "material-table";
import table_icons from "../../tableIcons";
import { Typography, Button, makeStyles } from "@material-ui/core";
import { AddCircleOutline } from "@material-ui/icons";
import { format } from "date-fns";
import SnackBar from "../../Snackbar/index";

import SecureWrapper from "../../Security/SecureWrapper";

const blue_theme = createTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#dc014e",
    },
  },
});

const useStyles = makeStyles(() => ({
  button: {
    width: "80px",
    background: "#127DFC",
    textTransform: "none",
    color: "#FFFFFF",
    float: "right",
    margin: "10px",
    // boxShadow: "0px 3px 6px #0000001A",
    border: "none",
    borderRadius: "5px",
    "&:hover": {
      backgroundColor: "#0069d9",
      borderColor: "#0062cc",
      boxShadow: "none",
    },
  },
}));

const renderNameAndEmail = (user, rowData) => {
  // console.log("rddd", rowData);
  return (
    <>
      <p
        style={{
          fontSize: "13px",
          color: user === rowData.email ? "#FFF" : "#222222",
        }}
      >
        {rowData?.name ? rowData?.name : "-"} <br />
        <span
          style={{
            fontSize: "13px",
            color: user === rowData.email ? "#FFF" : "#222222",
            fontWeight: "bold",
          }}
        >
          {rowData?.email}
        </span>
      </p>
    </>
  );
};

const UserTable = (props) => {
  const classes = useStyles();
  const {
    data,
    toggle,
    setToggle,
    setSelectedData,
    isNew,
    setIsNew,
    deleted,
    setdeleted,
    isCreate,
    newdata,
    setisCreate,
  } = props;
  // console.log("uuut", data);
  const [user, setUser] = useState(null);
  const [open, setopen] = useState(false);
  const [isdeleted, setisdeleted] = useState(false);
  useEffect(() => {}, [data, user]);

  const handleNewUser = () => {
    // if (user === null) {
    // console.log("new clicked");
    setIsNew(true);
    setUser(null);
    setToggle(false);
    // } else {
    //   setIsNew(false);
    // }
  };

  const handleRowSelected = (rowData) => {
    // console.log("rowData", rowData);
    if (user === rowData?.email) {
      setToggle(!toggle);
      setUser(null);
    } else {
      setToggle(true);
      setUser(rowData?.email);
    }
    setSelectedData(rowData);
    setIsNew(false);
  };
  useEffect(() => {
    data?.result?.map((row) => {
      if (row.email === user) {
        setSelectedData(row);
      }
      if (isCreate && row.email === newdata) {
        setSelectedData(row);
        setUser(row.email);
        setToggle(true);
        setisCreate(false);
      }
    });
  }, [data]);
  console.log("alllluser dara", data, newdata, user);
  useEffect(() => {
    if (deleted === true) {
      setToggle(!toggle);
      setUser(null);
      setdeleted(false);
      setisdeleted(true);
    }
    if (isCreate) {
      setopen(true);
    }
  });
  const onClose = () => {
    setopen(false);
  };
  const onClosedeleted = () => {
    setisdeleted(false);
  };
  return (
    <ThemeProvider theme = {blue_theme}>
    <div style={{ maxWidth: "100%", display: "flex", flexDirection: "column" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h6 style={{ paddingLeft: "10px" }}>All Users</h6>
        <SecureWrapper
            access_object = {{
              operation : "/sainapse/sign_up",
              method : "POST",
              operands : []
            }}
          >
          <Button
            // className={classes.button}
            variant = 'contained'
            size = 'small'
            color = 'primary'
            style={{margin: '10px', visibility: isNew ? "hidden" : "visible" }}
            startIcon={<AddCircleOutline />}
            onClick={handleNewUser}
          >
            New
          </Button>
        </SecureWrapper>
      </div>
      <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/user",
                        method : "GET",
                        operands : []
                      }}
                      shouldRenderErrorMessage = {true}
                      errorMessage = "User does not have sufficient privileges"
                      textVariant = "subtitle2"
        >
      <MaterialTable
        data={data?.result}
        icons={table_icons}
        columns={[
          {
            title: "User",
            field: "name",
            type: "string",
            searchable: true,
            cellStyle: {
              width: "25rem",
              //   textAlign: "center",
            },
            render: (rowData) => {
              // console.log("rowData---------->", rowData);
              // return renderNameAndEmail(user, rowData);
              return (
                <div>
                  <div
                    style={{
                      color: user === rowData.email ? "#FFF" : "#222222",
                      fontWeight: "bold",
                    }}
                  >
                    {rowData?.name ? rowData?.name : "-"}
                  </div>
                  <div
                    style={{
                      color: user === rowData.email ? "#FFF" : "#707071",
                      fontWeight: "bold",
                    }}
                  >
                    {rowData?.email}
                  </div>
                </div>
              );
            },
          },
          {
            title: "email",
            field: "email",
            hidden: true,
            searchable: true,
            type: "string",
          },
          {
            title: "Active Since",
            field: "created_date",
            type: "date",
            sorting: true,
            cellStyle: {
              width: "15rem",
              color: "#707071",
              fontWeight: "bold",
              // textAlign: "center",
            },
            render: (rowData) => {
              return (
                <Typography variant = 'caption' color = 'textSecondary'>{format(new Date(rowData?.created_date), "dd MMM yyyy")}</Typography>
                // <div
                //   style={{
                //     color: user === rowData.email ? "#FFF" : "#707071",
                //   }}
                // >
                //   {format(new Date(rowData?.created_date), "dd MMM yyyy")}
                // </div>
              );
            },
          },
          {
            title: "Groups",
            field: "groups",
            sorting: true,
            cellStyle: {
              // width: "2rem",
              color: "#222222",
              fontWeight: "bold",
              // textAlign: "center",
            },
            render: (rowData) => {
              return (
                <div
                  style={{
                    color: user === rowData.email ? "#FFF" : "#222222",
                  }}
                >
                  {rowData?.groups?.length}
                </div>
              );
            },
          },
          // {
          //   title: "Roles",
          //   field: "user_roles",
          //   sorting: true,
          //   cellStyle: {
          //     // width: "2rem",
          //     color: "#222222",
          //     fontWeight: "bold",
          //     // textAlign: "center",
          //   },
          //   render: (rowData) => {
          //     return (
          //       <div
          //         style={{
          //           color: user === rowData.email ? "#FFF" : "#222222",
          //         }}
          //       >
          //         {rowData?.user_roles?.length}
          //       </div>
          //     );
          //   },
          // },
          // {
          //   title: "",
          //   render: (rowData) => {
          //     return renderEventGroupActions(user, rowData);
          //   },
          //   cellStyle: {
          //     width: "5rem",
          //   },
          // },
        ]}
        components={{
          Toolbar: (props) => (
            <div style={{ background: "#F8FCFF" }}>
              <MTableToolbar {...props} />
            </div>
          ),
        }}
        options={{
          // search: false,
          // toolbar: false,
          showTitle: false,
          paging: true,
          actionsColumnIndex: 5,
          actionsCellStyle: {
            // background: "grey",
          },
          minBodyHeight: "67.5vh",
          maxBodyHeight: "67vh",
          //   pageSizeOptions: [10, 20, 30],
          pageSize: 10,
          headerStyle: {
            background: "#F8FCFF",
            color: "#707071",
            // fontSize: "1rem",
            // fontWeight: "bold",
            // padding: "0px 10px",
            // textJustify: "inter-word",
          },
          overflow: "auto",
          rowStyle: (rowData) => ({
            backgroundColor: user === rowData.email ? "#70BAFA" : "#FFF",
            margin: "10px 0px",
            boxShadow: "0px 3px 6px #00000029",
            borderRadius: "5px",
            position: "relative",
          }),
        }}
        onRowClick={(event, rowData) => {
          handleRowSelected(rowData);
        }}
      />
      </SecureWrapper>
      {open && (
        <SnackBar
          openDialog={open}
          message={"User has been created successfully"}
          onclose={onClose}
          severity={"success"}
        />
      )}
      {isdeleted && (
        <SnackBar
          openDialog={isdeleted}
          message={"User has been deleted successfully"}
          onclose={onClosedeleted}
          severity={"success"}
        />
      )}
    </div>
    </ThemeProvider>
  );
};

export default UserTable;
